/** @jsx jsx */
import { h, FunctionalComponent, Fragment } from 'preact'
import { jsx } from '@emotion/core'

import { getDefaultMatchupStylesObj, getDivider } from './matchup.styles'
import { TeamObject } from '../../types/props'
import { useSiteVars } from '../../themes/useSiteVars'

interface MatchupProps {
    homeTeam: TeamObject
    awayTeam: TeamObject
    homeRecord?: string
    awayRecord?: string
    date?: string
    channel?: string
    odds?: string
    preview?: boolean
    time?: string
}

const Matchup: FunctionalComponent<MatchupProps> = ({
    homeTeam: homeTeamRaw,
    awayTeam: awayTeamRaw,
    homeRecord,
    awayRecord,
    date,
    time,
    channel,
    odds,
    preview,
}) => {
    const siteVars = useSiteVars()
    const MatchupStyles = getDefaultMatchupStylesObj(siteVars, preview)

    let homeTeam = homeTeamRaw
    if (typeof homeTeamRaw === 'string') {
        homeTeam = JSON.parse(homeTeamRaw)
    }

    let awayTeam = awayTeamRaw
    if (typeof awayTeamRaw === 'string') {
        awayTeam = JSON.parse(awayTeamRaw)
    }

    return (
        <Fragment>
            <div css={MatchupStyles.title}>Matchup</div>
            <div css={MatchupStyles.root}>
                <div css={MatchupStyles.header}>
                    <div css={MatchupStyles.teamWrapper} className="away">
                        <div css={MatchupStyles.team}>
                            <span css={MatchupStyles.logo}>
                                <img src={awayTeam.logoUrl} />
                            </span>
                            <span css={MatchupStyles.teamName}>{awayTeam.shortName}</span>
                        </div>
                        {awayRecord && <span css={MatchupStyles.record}>{awayRecord}</span>}
                    </div>
                    <div css={MatchupStyles.teamWrapper}>
                        <div css={MatchupStyles.team}>
                            {homeTeam.logoUrl && (
                                <span css={MatchupStyles.logo}>
                                    <img src={homeTeam.logoUrl} />
                                </span>
                            )}
                            <span css={MatchupStyles.teamName}>{homeTeam.shortName}</span>
                        </div>
                        {homeRecord && <span css={MatchupStyles.record}>{homeRecord}</span>}
                    </div>
                </div>
                <div css={MatchupStyles.contentWrapper}>
                    <div css={MatchupStyles.content}>
                        {date && <span>{date}</span>}
                        {date && time && <span css={getDivider(siteVars, null, null, null, preview, time)} />}
                        {date && time && <span>{time}</span>}
                        {date && (channel || odds) && <span css={getDivider(siteVars, null, channel, odds, preview)} />}
                        {channel && <span>{channel}</span>}
                        {channel && odds && <span css={getDivider(siteVars, null, channel, odds)} />}
                        {odds && <span>{odds}</span>}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Matchup
